import { createSelector, createStructuredSelector } from 'reselect';
import memoize from 'lodash.memoize';

export default function resourceListSelectorFactory(getAllOfResource, rootApi) {
  return memoize(function (selector, api) {
    return createSelector(selector, getAllOfResource, function (s) {
      return s;
    }, function (list, allResources, state) {
      return list.map(function (idOrResource) {
        var selectorOrStructured = api(rootApi(function () {
          return typeof idOrResource === 'string' ? allResources[idOrResource] : idOrResource;
        }));

        if (typeof selectorOrStructured === 'function') {
          return selectorOrStructured(state);
        }

        return createStructuredSelector(selectorOrStructured)(state);
      });
    });
  });
}